import React from 'react';
import { Link } from 'react-router-dom';

const SOLUTION_CHILD_HERO_BACKGROUND = `${process.env.PUBLIC_URL}/images/backgrounds/solution-child-hero-bg.webp`;

const SOLUTION_CHILD_HERO_BAND_STYLE = {
  '--brand-marketing-hero-image': `url(${SOLUTION_CHILD_HERO_BACKGROUND})`,
};

/** Paths only; aspect ratio comes from each SVG viewBox. */
export const SOLUTION_CHILD_HERO_ILLUSTRATIONS = {
  context: '/images/features/icon_Business-context-hero.svg',
  triage: '/images/features/icon_Intelligent-insights-hero.svg',
  remediation: '/images/features/icon_Assisted-remediation-hero.svg',
};

const SolutionChildHero = ({ headingId, eyebrow, title, lead, illustration }) => (
  <section
    className="page-hero page-hero--marketing page-hero--split solution-child-page__hero-band"
    aria-labelledby={headingId}
    style={SOLUTION_CHILD_HERO_BAND_STYLE}
  >
    <div className="page-container">
      <div className="page-hero--split__grid">
        <div className="page-hero--split__copy">
          <p className="page-hero__eyebrow">{eyebrow}</p>
          <h1 id={headingId} className="page-hero__title">
            {title}
          </h1>
          <p className="page-hero__lead">{lead}</p>
          <p>
            <Link to="/solutions" className="solution-child-page__back solution-child-page__back--hero">
              ← All solutions
            </Link>
          </p>
        </div>
        <div className="page-hero--split__media solution-child-page__hero-media" aria-hidden="true">
          <img
            className="solution-child-page__hero-img"
            src={illustration}
            alt=""
            loading="eager"
            decoding="async"
          />
        </div>
      </div>
    </div>
  </section>
);

export default SolutionChildHero;
